import { IObserver } from "./IObserver";
import { IUpdatable } from "./IUpdatable";

/**
 *    ObserverManager
 *
 *     @author Alexander
 */

export class ObserverManager implements IObserver {

    private observerData: IUpdatable[];

    constructor() {
        this.observerData = [];
    }

    /**
     * add IBasicData only once
     */
    public subscribeOnce(observer: IUpdatable): void {
        let totObs: number = this.observerData.length;

        for (let i: number = 0; i < totObs; i++) {
            if (observer === this.observerData[i]) {
                return;
            }
        }
        this.observerData.push(observer);
    }

    /**
     * add IBasicData
     * Attention!! could be added more than once
     */
    public subscribe(observer: IUpdatable): void {
        this.observerData.push(observer);
    }

    /**
     * remove IBasicData
     */
    public unsubscribe(observer: IUpdatable): void {
        let totObs: number = this.observerData.length;

        for (let i: number = 0; i < totObs; i++) {
            if (observer === this.observerData[i]) {
                this.observerData.splice(i, 1);
                break;
            }
        }
    }

    /**
     * remove all IBasicData
     */
    public unsubscribeAllObserver(): void {
        this.observerData = [];
    }

    /**
     * updates all IBasicData
     */
    public notify(now: number): void {
        // Go backwards from the last item to the first one, so If any item will unregister itself
        // during it's update method, idexes will stay correct.
        for (let i: number = this.observerData.length - 1; i >= 0; i--) {
            this.observerData[i].update(now);
        }
    }
}
